"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppApolloProvider = void 0;
const react_1 = __importStar(require("react"));
const client_1 = require("@apollo/client");
const recompose_1 = require("recompose");
const enums_1 = require("@vamstar/fox-api-common/esm/common/enums");
const fox_node_logger_1 = require("@vamstar/fox-node-logger");
const notistack_1 = require("notistack");
const utils_1 = require("../../utils");
const DefaultFallback_1 = require("../DefaultFallback");
const LOGOUT_DELAY = 2500;
class AppApolloProviderView extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.state = {
            client: null,
            isLoading: true,
        };
        /**
         * Navigates to login if the token is expired
         * checks for the TOKEN_EXPIRED or UNAUTHORIZED code if part of graphql errors
         * @param graphqlErrors - graphql errors returned from the server
         * */
        this.navigateToLogin = (graphqlErrors) => {
            const { clearAuthData } = this.props;
            const isUnauthorized = graphqlErrors.some((gqlErr) => gqlErr.extensions &&
                (gqlErr.extensions.code === enums_1.ErrorType.TOKEN_EXPIRED || gqlErr.extensions.code === enums_1.ErrorType.UNAUTHORIZED));
            if (isUnauthorized) {
                setTimeout(() => clearAuthData(), LOGOUT_DELAY);
            }
        };
        /**
         * handles apollo errors and shows useful messages to the user on error
         * */
        this.handleApolloError = ({ graphQLErrors, networkError }) => {
            if (graphQLErrors) {
                this.handleGraphqlErrors(graphQLErrors);
                this.navigateToLogin(graphQLErrors);
            }
            if (networkError && !graphQLErrors) {
                this.handleNetworkError(networkError);
            }
        };
        /**
         * Shows user notification with the translation if graphql error occurs
         * */
        this.handleGraphqlErrors = (graphQLErrors) => {
            const { enqueueSnackbar, t } = this.props;
            graphQLErrors.forEach((gqlErr) => {
                fox_node_logger_1.log.error(`Graphql error occurred ${JSON.stringify(gqlErr)}`);
                const errorMessage = gqlErr.message;
                enqueueSnackbar(t(errorMessage), { variant: 'error' });
            });
        };
    }
    /**
     * creates the apollo client on app load and sets persist apollo cache
     * */
    componentDidMount() {
        return __awaiter(this, void 0, void 0, function* () {
            const { persistApolloCache, cache, request } = this.props;
            try {
                const apolloClient = utils_1.createApolloClient(cache, this.handleApolloError, request, `${process.env.REACT_APP_SERVER_URL}/api`);
                if (persistApolloCache) {
                    yield persistApolloCache();
                    fox_node_logger_1.log.info(`Cache initialised!`);
                }
                this.setState({ client: apolloClient });
            }
            catch (err) {
                fox_node_logger_1.log.error(`App loading failed! ${err}`);
            }
            finally {
                this.setState({ isLoading: false });
            }
        });
    }
    /**
     * Shows user notification on network error
     * */
    handleNetworkError(networkError) {
        const { t, enqueueSnackbar } = this.props;
        fox_node_logger_1.log.error(`Network error occurred ${JSON.stringify(networkError)}`);
        enqueueSnackbar(t('unknownError'), { variant: 'warning' });
    }
    render() {
        const { client, isLoading } = this.state;
        const { children } = this.props;
        if (isLoading || !client) {
            return react_1.default.createElement(DefaultFallback_1.DefaultFallback, null);
        }
        return (react_1.default.createElement(client_1.ApolloProvider, { client: client },
            react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(DefaultFallback_1.DefaultFallback, null) }, children)));
    }
}
exports.AppApolloProvider = recompose_1.compose(notistack_1.withSnackbar)(AppApolloProviderView);
//# sourceMappingURL=data:application/json;base64,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